import React from "react";
import "assets/css/safexpay-web.css";
import "./Policy.css";

class Policy extends React.Component {
  righthandler = () => {
    document.addEventListener('contextmenu', event => event.preventDefault());
    }
    
    componentDidMount() {
      this.righthandler();
    }
  render() {
    return (
      <>
        <section className="dv-Policy-content">
          <div
            className="container"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <div className="row">
              <p className="font-s19">
                <p>
                  Paygate India Private Limited(&lsquo;Paygate&rsquo;) and all
                  its subsidiaries (includes all subsidiaries across globe) are
                  committed for protecting and respecting your information that
                  will be provided by you by filling the forms on our site. The
                  Privacy Policy has been prepared to ensure that your privacy
                  is protected and secured. You can be assured that we shall use
                  your personal information only in accordance with this Privacy
                  Policy. Please read and understand carefully that the
                  PaygatePrivacy Policy is to know our views and practices
                  regarding your personal data and on how we use it.
                </p>
                <p>
                  <strong>
                    The Information which you have provided at the time of
                    registration on our website and{" "}
                  </strong>
                  <strong>
                    while subscription of our various services this may include
                    but not limited to:{" "}
                  </strong>
                </p>
                <ul>
                  <li>Name</li>
                  <li>Designation</li>
                  <li>Contact information including email address.</li>
                  <li>Business information.</li>
                  <li>
                    Demographic information like postcodes, preferences and
                    interests.
                  </li>
                  <li>
                    Any other information related / relevant to our application
                    process.
                  </li>
                </ul>
                <p>
                  <strong>Why we collect your information?&nbsp;</strong>
                </p>
                <ol>
                  <li>
                    <strong> To personalize user experience:&nbsp;</strong>
                  </li>
                </ol>
                <p>
                  We may use information to understand how our users as a group
                  use the services and resources provided on Paygate
                  Website.&nbsp;
                </p>
                <ol start="2">
                  <li>
                    <strong> To improve customer service:&nbsp;</strong>
                  </li>
                </ol>
                <p>
                  Your information helps us to respond more effectively to your
                  customer service requests, enquiry and support needs.&nbsp;
                </p>
                <ol start="3">
                  <li>
                    <strong> To process your application:&nbsp;</strong>
                  </li>
                </ol>
                <p>
                  We use the information collected to understand the nature and
                  profile of your business and accordingly approve or decline
                  your application.&nbsp;
                </p>
                <ol start="4">
                  <li>
                    <strong> For marketing purposes:&nbsp;</strong>
                  </li>
                </ol>
                <p>
                  We may use your information for promotional activities of our
                  new products and features, special offers and for advertising
                  our products and services.&nbsp;
                </p>
                <ol start="5">
                  <li>
                    <strong> To periodic Communications:&nbsp;</strong>
                  </li>
                </ol>
                <p>
                  The email/contact number/address provided will be used to send
                  information and updates pertaining to our site and our
                  services. It may also be used to respond to your enquiry,
                  and/or other requests. If the user decides to opt-in to our
                  mailing list, they will receive emails that may include
                  Paygate news, updates, related product or service information,
                  etc.
                </p>
                <p>
                  <strong>Data Storage and access&nbsp;</strong>
                </p>
                <p>
                  The data we collect from you is stored in our system servers
                  and will be treated with utmost confidentiality. Your personal
                  information will be used only by Paygate for all business
                  transactions that require your information to complete the
                  transactions.&nbsp;
                </p>
                <p>
                  <strong>Disclosure of your Information&nbsp;</strong>
                </p>
                <p>
                  Paygate may disclose your personal information to any of our
                  subsidiaries.&nbsp;
                </p>
                <p>
                  For the further growth of the Paygate, we may acquire any
                  business or asset. In such case we may disclose your personal
                  data to the prospective buyer of such business or
                  assets.&nbsp;
                </p>
                <p>
                  Paygate may transfer information that we collect about you,
                  including personal information across borders and from your
                  country or jurisdiction to other countries or jurisdictions
                  around the world. Note that we may transfer information,
                  including personal information, to a country and jurisdiction
                  that does not have the same data protection laws as your
                  jurisdiction.&nbsp;
                </p>
                <p>
                  In case Paygate or its Subsidiaries are acquired by a third
                  party, in which case information held by it about its
                  customers will be one of the transferred assets. If we are
                  under a duty to disclose or share your personal data in order
                  to comply with any legal obligation, or in order to enforce or
                  apply our terms of use and other agreements; or to protect the
                  rights, property or safety of us, our customers, or others.
                  This includes exchanging information with other companies and
                  organisations for the purposes of fraud protection and credit
                  risk reduction.&nbsp;
                </p>
                <p>
                  Paygate may allow a third-party application to access your
                  information in cases where a need arises for verification of
                  your data and other validation purposes. Paygate ensures that
                  verification processes used by third party application will
                  help to make your account safe from fraud or any money
                  laundering.&nbsp;
                </p>
                <p>
                  <strong>Security and Retention:&nbsp;</strong>
                </p>
                <p>
                  Paygate recognizes its responsibility to keep confidential and
                  secure at all times any information that Paygate receives in
                  connection with a transaction. Paygate has all the necessary
                  electronic and physical procedures in place to keep your
                  information secure in order to prevent any unauthorized
                  access. When you log into your Paygate account, all Internet
                  communication is secured using Secure Socket Layer (SSL)
                  technology with 256-bit encryption security. For your own
                  safety, please make sure never to share your Paygate login
                  details with anyone.&nbsp;
                </p>
                <p>
                  Notwithstanding anything contained in this Policy or
                  elsewhere, to the extent permissible under applicable laws,
                  Paygate shall not be held responsible for any loss, damage or
                  misuse of your Personal Information/Non-Personal
                  Information/Sensitive Personal Information, if such loss,
                  damage or misuse is attributable to a Force Majeure Event (as
                  defined below).&nbsp;
                </p>
                <p>
                  A <strong>Force Majeure </strong>Event shall mean any event
                  that is beyond the reasonable control of Paygateand shall
                  include, without limitation, sabotage, fire, flood, explosion,
                  acts of God, civil commotion, strikes or industrial action of
                  any kind, riots, insurrection, war, acts of government,
                  computer hacking, epidemic, unauthorised access to computer,
                  computer system or computer network, computer crashes, breach
                  of security and encryption (provided beyond reasonable control
                  of Paygate), power or electricity failure or unavailability of
                  adequate power or electricity.
                </p>
                <p>
                  <strong>Internet Cookies&nbsp;</strong>
                </p>
                <p>
                  Cookies are text files, used by your computer's browser, that
                  store visitor session data. Cookies, by themselves, do not
                  identify the individual user. Cookies are commonly used on the
                  Internet and do not harm your system.&nbsp;
                </p>
                <p>
                  Cookies are mainly used to measure web traffic, for keeping
                  records and to let you know when you visit a particular site.
                  But cookies never give us access to any other information
                  other than what you choose to share with us.&nbsp;
                </p>
                <p>
                  Cookies also help us in analysing data to be used in improving
                  our website, eventually giving you a better user experience.
                  Users generally have the options to accept or decline cookies.
                  However, please note that you will not get the full benefit of
                  using the website if you choose to decline.&nbsp;
                </p>
                <p>
                  When you registered on our website information about your
                  computer, including where available is your IP address,
                  operating system and browser type for system administration
                  will be recorded. We may collect same information on email or
                  by any other mode of communication. This is statistical data
                  about our users&rsquo; browsing actions and patterns and does
                  not identify any individual. This is required for the for more
                  accurate reporting and improvement in the services.&nbsp;
                </p>
                <p>
                  <strong>Third Party Websites&nbsp;</strong>
                </p>
                <p>
                  Users may find advertising or other content on our Site that
                  link to the sites and services of our partners, suppliers,
                  advertisers, sponsors, licensors and other third parties.
                  Paygate does not control the content or links that appear on
                  these sites and are not responsible for the practices employed
                  by those websites.&nbsp;
                </p>
                <p>
                  Browsing and interaction on any other website, including
                  websites which have a link to our Site, is subject to that
                  website's own terms and policies. Paygate does not guarantee
                  protection and privacy of information that you may provide to
                  such websites.&nbsp;
                </p>
                <p>
                  <strong>Updating your Information&nbsp;</strong>
                </p>
                <p>
                  If your personal or professional information (such as your
                  name, address, or telephone number) needs change, you must
                  update your details by contacting Paygate on our contact us
                  page.&nbsp;
                </p>
                <p>
                  To avoid inconvenience to all, Paygate strongly advises
                  keeping all information up to date and correct. Paygate will
                  be exempt from any responsibility in the rare event where
                  losses may arise from not updating your information.&nbsp;
                </p>
                <p>
                  <strong>Jurisdiction:</strong>
                </p>
                <p>
                  This Privacy Policy is governed by and shall be construed in
                  accordance with the laws of Republic of India and any disputes
                  arising out of or in connection with this Agreement shall be
                  subject to jurisdiction of the Courts of Mumbai, India.
                </p>
                <p>
                  <strong>Indemnity:&nbsp;</strong>
                </p>
                <p>
                  You shall indemnify and hold harmless Companies, its officers,
                  directors, contractors or agents and any third parties relying
                  on the information provided by you for any losses, including
                  all claims, damages, liabilities, deficiencies, assessments,
                  interest, awards, settlements, penalties,&nbsp;
                </p>
                <p>
                  fines, costs or expenses, suffered, incurred, sustained by, or
                  imposed on Safexpay, as a result of, arising out of, with
                  respect to, in connection with or by reason of a breach or
                  non-performance of any of the terms, conditions,
                  representations, warranties or covenants contained in this
                  Privacy Policy by You.
                </p>
                <p>
                  <strong>Other Websites and Services </strong>
                </p>
                <p>
                  We are not responsible for the practices employed by any
                  websites or services linked to or from our Service, including
                  the information or content contained mention there. Please
                  remember that when you use a link to go from our Service to
                  another website or service, our Privacy Policy does not apply
                  to those third-party websites or services.
                </p>
                <p>
                  You&rsquo;re browsing and interaction on any third-party
                  website or service, including those that have a link on our
                  website, are subject to that third party&rsquo;s own rules and
                  policies. Further, you agree that we are not responsible and
                  do not have control over any third-parties website/Services
                  that you authorize to access your User Content. If you are
                  using a third-party website or service and you allow them to
                  access your User Content you do so at your own risk.&nbsp;
                </p>
                <p>
                  <strong>Customer Rights:&nbsp;</strong>
                </p>
                <p>
                  We acknowledge and agree the individual&rsquo;s right to
                  access their Personal Data. We shall allow an individual
                  access to their Personal Data further we allow the individual
                  the occasion to correct, amend or delete inaccurate
                  information, except where the burden or expense of providing
                  access would be disproportionate to the risks to the privacy
                  of the individual is in question or where the rights of
                  persons other than the individual would be violated.
                  Individuals may contact our Privacy Officer via email to
                  request access. Contact information can be found below.
                </p>
                <p>Grievance redressal:&nbsp;</p>
                <p>
                  Please write your concerns to:{" "}
                  <strong>For Paygate India Private Limited:&nbsp;</strong>
                </p>
                <ul>
                  <li>Contact on: Email: care@safexpay.com</li>
                </ul>
                {/* <p>
                  If your concern/query remains unresolved, can escalate the
                  matter to our Grievance/Nodal officer. The details of the
                  Grievance/Nodal Officer is provided below:&nbsp;
                </p> */}
                <p>For Paygate India Private Limited:&nbsp;</p>
                <ul>
                  <li>Email: legal@safexpay.com</li>
                  <li>
                    Address- 718, 7th Floor, Lodha Supremous-2, Wagle Estate,
                    Thane West, Maharashtra 400604, India.&nbsp;
                  </li>
                  <li>Working hours: 9 a.m. to 7 p.m.&nbsp;</li>
                </ul>
                <p>
                  Paygate reserves the right to amend this policy at any point
                  in time on its discretion and accordingly update this page.
                  Please check this page periodically to make sure you are happy
                  with the changes.
                </p>
                <p>Policy w.e.f. 01st January 2021</p>
              </p>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Policy;
